import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { Grid } from '@material-ui/core';

import { IncompleteTasksNotification } from 'common/components/notifications/incomplete-tasks-notification';
import NotificationType from 'core/helpers/notifications';
import { NotificationCard } from 'core/components/notification-card';
import { useStore } from 'core/store';
import { SignedDocumentsNotification } from '../signed-documents-notification';
import { PendingThirdPartyNotification } from '../pending-third-party-notification';
import { CrossSellEligibilityNotification } from 'customer/components/cross-sell-eligibility-notification';
import { SuspiciousAccountNotification } from 'customer/components/suspicious-account-notification';

const Notification = {
  [NotificationType.Policy.CrossSellEligibility]: CrossSellEligibilityNotification,
  [NotificationType.Policy.SignedConversionDocuments]: SignedDocumentsNotification,
  [NotificationType.Policy.PendingThirdPartyPurchases]: PendingThirdPartyNotification,
  [NotificationType.Policy.SuspiciousAccount]: SuspiciousAccountNotification,
  [NotificationType.Customer.IncompleteTasks]: IncompleteTasksNotification
};

const PolicyNotifications = observer(({ type, onClick }) => {
  const {
    account: { policies: policiesStore }
  } = useStore();
  return (
    <Grid id="notificationsContainer">
      {policiesStore.notifications.map((notificationType) => {
        const NotificationComponent = Notification[notificationType];
        return (
          <NotificationCard key={notificationType} type={type}>
            <NotificationComponent onClick={onClick} fromPolicy />
          </NotificationCard>
        );
      })}
    </Grid>
  );
});

PolicyNotifications.propTypes = {
  onClick: PropTypes.func
};

PolicyNotifications.defaultProps = {
  onClick: null
};

export default PolicyNotifications;
